// extracted by mini-css-extract-plugin
module.exports = {"profile":"UserProfileIcon_profile__1Fe8A"};